import React, { useState } from 'react';

const JOIN_URL = 'https://play.google.com/apps/testing/za.co.grandgatherregistry.twa';
const DISMISS_KEY = 'ggr-beta-banner-dismissed';
const RESHOW_MS = 2 * 24 * 60 * 60 * 1000;

function isDismissed() {
  try {
    const t = JSON.parse(localStorage.getItem(DISMISS_KEY) || 'null');
    return t && (Date.now() - t) < RESHOW_MS;
  } catch (e) {
    return false;
  }
}

export default function BetaBanner() {
  const [hidden, setHidden] = useState(isDismissed);
  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, JSON.stringify(Date.now())); } catch (e) {}
    setHidden(true);
  };

  return (
    <div style={{
      margin: '12px 16px 0',
      padding: '12px 14px',
      borderRadius: '14px',
      background: 'linear-gradient(120deg, var(--rose, #E05B6C), #C13A54)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      boxShadow: '0 6px 20px rgba(224,91,108,0.35)',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{ fontSize: '26px', flexShrink: 0 }}>🎁</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '13.5px', fontWeight: 700, marginBottom: '2px' }}>
          GGR is coming to the Google Play Store!
        </div>
        <div style={{ fontSize: '12px', opacity: 0.92, lineHeight: 1.4 }}>
          Be one of the first in Mzansi — join our beta testing programme, it takes 10 seconds.
        </div>
      </div>
      <button
        onClick={() => window.open(JOIN_URL, '_blank', 'noopener')}
        style={{
          flexShrink: 0,
          background: '#fff',
          color: '#C13A54',
          border: 'none',
          borderRadius: '10px',
          padding: '8px 14px',
          fontSize: '12.5px',
          fontWeight: 700,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          fontFamily: 'Inter, sans-serif',
        }}
      >
        Join Beta
      </button>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          flexShrink: 0,
          background: 'rgba(255,255,255,0.18)',
          border: 'none',
          color: '#fff',
          borderRadius: '8px',
          width: '26px',
          height: '26px',
          fontSize: '13px',
          cursor: 'pointer',
          lineHeight: 1,
        }}
      >✕</button>
    </div>
  );
}
